export enum MiniHomeSort {
  NORMAL,
  SALES,
  NEW,
  PRICE_ASC,
  PRICE_DESC,
  PRICE, // placeholder for PRICE_ASC
}

export class MiniHomeSorts {
  static toString(sort: MiniHomeSort): string {
    switch (sort) {
      case MiniHomeSort.NORMAL:
        return $localize`綜合`;
      case MiniHomeSort.SALES:
        return $localize`銷量`;
      case MiniHomeSort.NEW:
        return $localize`新品`;
      case MiniHomeSort.PRICE_ASC:
        return $localize`價格`;
      case MiniHomeSort.PRICE_DESC:
        return $localize`價格`;
      case MiniHomeSort.PRICE:
        return $localize`價格`;
    }
  }

  static icon(sort: MiniHomeSort): string {
    switch (sort) {
      case MiniHomeSort.PRICE_ASC:
        return 'assets/icon_price_asc.svg';
      case MiniHomeSort.PRICE_DESC:
        return 'assets/icon_price_desc.svg';
      case MiniHomeSort.PRICE:
        return 'assets/icon_price_sort.svg';
      default:
        return '';
    }
  }
}
